<template>
  <div class="row">
    <div class="closeButton">
        <button class="btn btn-danger" type="button" @click="closeUpdatesScreen">{{translate('close')}}</button>
    </div>
    <div class="col">
      <Version
        v-for="version in allVersions"
        :key="version.number"
        :number="version.number"
        :groups="version.groups">
      </Version>
    </div>
  </div>
</template>

<script>
import Version from '../components/Version.vue'

export default {
    components: {
        Version,
    },
    created(){
        const savedLanguage = localStorage.getItem('language');
        console.log("savedLang", savedLanguage)
        if(this.hideVersionDetails)
            this.$router.push('/' + this.$root.$data.login.Account.Code);
        if(savedLanguage == "en"){
            this.$router.push('/' + this.$root.$data.login.Account.Code + '/updates-en')
        }
    },
    methods: {
        closeUpdatesScreen(){
            this.$router.push('/' + this.$root.$data.login.Account.Code);
        }  
    },
    computed: {
        hideVersionDetails(){
        if(this.hasAuth("Admin"))
            return false;
        else
            return window.settings.customization.hideVersionDetails ? true : false;  
        },
        allVersions(){
            return [
                {
                    number : "2.13.2",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "UETS Gelen Kutusu eklendi",
                                "Alıcı olarak API seçeneği eklendi. API özelliğini kullanarak imzalı belgelerinizi kendi uygulamanıza aktarabilirsiniz.",
                                "PDF görüntüleyici yenilendi."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Tasarımsal düzenlemeler.",
                                "Güvenlik düzenlemeleri.",
                                "Performans iyileştirmeleri.",
                                "Entegrasyon iyileştirmeleri."
                                
                            ]
                        }
                    ]
                },{
                    number : "2.13.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Mobil uygulama üzerinden KEP imzalama desteği eklendi.",
                                "PDF birleştirme özelliği eklendi. İş oluştururken, birden fazla PDF dokümanı tek bir dokümana dönüştürebilirsiniz.",
                                "Banka talimatları ekranı geliştirildi.",
                                "KEP gönderimlerinde dosya boyutu limiti 35 MB'a yükseltildi.",
                                "Alıcı taslakları desteği eklendi. Alıcı tanımlarında tüm verileri doldurmak yerine taslaklardan seçim yaparak ilerleyebilirsiniz.",
                                "DETSİS üzerinden kurum sorgulamalarda, üst kurum bilgisi eklendi."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Tasarımsal düzenlemeler.",
                                "Güvenlik düzenlemeleri.",
                                "Performans iyileştirmeleri."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.2",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "İmzalayıcı'nın yeni versiyonu entegre edildi. MacOS ile imza atma özelliği eklendi.",
                                "Kullanıcılara SMS bilgilendirmesi eklendi.",
                                "Bankaların dekont (dosya deseni) formatları eklendi.",
                                "Şifreli dosya gönderimi eklendi.",
                                "Yanlış imza standardı seçiminin önüne geçebilmek için alıcılara imza standardı belirlenebilmesi eklendi.",
                                "Azure ile çoklu hesap girişi eklendi.",
                                "İngilizce dil desteği eklendi."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Tasarımsal düzenlemeler.",
                                "Güvenlik düzenlemeleri.",
                                "Banka talimat tutarı düzenlemesi."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Mail gönderimleri için OAuth desteği eklenmiştir.",
                                "Dış İmzacılar için belge görüntüleme özelliği eklenmiştir.",
                                "UETS ile gelen evraklara ulaşmak için online ödeme özelliği eklenmiştir(Sadece Bulut kullanıcıları için).",
                                "EYP oluşturma öncesi EYP Alıcı Tanımlama zorunluluğu kaldırıldı. İş oluştururken kurum bilgilerini doğrudan girebilirsiniz.",
                                "Minimum imzacı sayısının kategori bazlı belirlenebilmesi desteği eklenmiştir.",
                                "Adalet Bakanlığı'na gönderilen KEP iletileri için Barkod No alanı eklenmiştir."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Bazı PDF dosyalarındaki imza yerleştirme hataları giderilmiştir.",
                                "KEP Gelen Kutusu senkronizasyon iyileştirmeleri yapılmıştır",
                                "Tasarımsal düzenlemeler.",
                                "Güvenlik düzenlemeleri."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.12.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Gelen Evrak Modülü Eklenmiştir. Gelen Evraklarınıza filtreleme yaparak ilgili kullanıcılara/departmanlara yönlendirebilirsiniz.",
                                "UETS Entegrasyonu gerçekleştirilmiştir.",
                                "KEP iletilerini mobil imza ile imzalama özelliği eklenmiştir.",
                                "EYP dosyalarını mobil imza ile imzalama özelliği eklenmiştir.",
                                "E-Teminat mektuplarının mobil imza ile imzalama özelliği eklenmiştir.",
                                "Onaylama süreçlerini SMS ile OTP doğrulaması yaparak Zaman damgalı bir şekilde loglama opsiyonu eklenmiştir.",
                                "İmzalı PDF dosyalarının imzalanabilmesi özelliği eklenmiştir.",
                                "KEP iletilerini HSM ile imzalama özelliği eklenmiştir.",
                                "Dış Kullanıcıları kaydetme özelliği eklenmiştir.",
                                "İş içerisinde damga vergisi tanımlama özelliği eklenmiştir.",
                                "Müşterinin gönderilen iletilerin tasarımını ve metinlerini düzenleyebilmesi sağlanmıştır.",
                                "İmzalama altyapısı yenilenmiştir.",
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Dosya görüntüleme seçenekleri düzenlenmiştir.",
                                "Tasarımsal düzenlemeler.",
                                "Güvenlik düzenlemeleri."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.2",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Dış imzacı yönlendirme özelliği eklenmiştir.",
                                "İmza Doğrulama sayfasında doküman indirme ve görüntüleme özelliği eklenmiştir.",
                                
                               
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Güvenlik düzenlemeleri.",
                                "Tasarımsal düzenlemeler."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Kullanıcıların departman atamalarına özel Departman Yöneticisi yetkisi eklenmiştir.",
                                "CAdES imza profili için seri imza seçeneği eklenmiştir.",
                                "Mobil imzalama için sayaç eklenmiştir.",
                                "PDF dokümanların uzun dönemli olarak imzalanması özelliği eklenmiştir.",
                                "Raporlar sayfasında (varsa) birden fazla alıcının gösterimi sağlanmıştır.",
                                "EYP gönderimlerinde iş detayı sayfasında alıcının DETSİS No ve Kurum Adı bilgilerinin gösterimi sağlanmıştır"
                               
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Güvenlik düzenlemeleri.",
                                "Boş doküman ekleme hatası giderilmiştir.",
                                "Dosya sistemi alıcılarında dosya yolu hatası giderilmiştir."
                                
                            ]
                        }
                    ]
                },
                {
                    number : "2.11.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "İmzacı/Onaycı seçim ekranında tüm kullanıcıların listelenmesi için filtre kaldırma butonu eklenmiştir.",
                                "EYP Oluştur butonunun yeri dolaşım bilgileri sayfasında sol tarafa alınmıştır.",
                                "İş oluştur / Kaydet butonu \"taslak olarak kaydet\"  olarak adlandırılmıştır.",
                                "İş Oluştur / Özet sayfasında alıcı kısmında cc'ye ve bcc'ye eklenen kişi bilgileri görüntülenebilmektedir.",
                                "İmza Yerleştir butonu ile, akış içerisinde bulunandan daha fazla imzacı eklenmesi engellenmiştir.",
                                "İmza Yerleştir ekranında, ilgili sayfada olmayan nesneler (pasif), tamamen görünmez olması sağlanmıştır.",
                                "Kullanıcılardan birinin imzası yeterli olduğundan imzalamayan kullanıcıya giden mail bildiriminde \"imzanız bekleniyor\" uyarısı yerine \"bilgilendirme\" başlığı ile mail gönderimi yapılmıştır.",
                                "İmza Yerleştir sayfasında doğrulama bağlantısı, doğrulama kodu vb. metinlerin içerikleri değiştirilememesi sağlanmıştır.",
                                "Hesap paratmerelerinden Email alıcıları için domain filtresi eklenebilmesi sağlanmıştır."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.10.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.2",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : 
                            [
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "KEP alıcılarında, kep adresine ek olarak Detsis No girilebilmesi sağlandı.",
                                "SFTP ve Dosya sistemi alıcılarında, imzalı dosyaların parametrik olarak belirlenebilen bir dizin altına bırakılabilmesi sağlandı.",
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Mobil İmza ile iş imzalarken 'İmza Yerleştir' ile belirlenen konuma yerleştirme yapılmaması sorunu giderildi."
                            ]
                        }
                    ]
                },
                {
                    number : "2.9.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "İş oluştur ekranında, dolaşıma çıkan dosyalara erişim sağlayabilecek kullanıcıların belirlenmesi için Gizlilik seçenekleri eklendi.",                                
                                "İş oluştur ekranında, işe özel akış oluşturmak veya tanımlı akışları özelleştirebilmek için 'Akış Özelleştirme' yetkisi eklendi.",
                                "İşlerim listesinde sıralamanın son aksiyon aldığım tarihe göre yapılması sağlandı.",
                                "İş üzerindeki dosyaların imzalama formatları gösterildi.",
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },                
                {
                    number : "2.8.3",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },  
                {
                    number : "2.8.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [                  
                                "Kullanıcı kimlik bilgilerine, Yabancı kimlik numarasının girilebilmesi sağlandı.",
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.8.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [                  
                                "PTTKep ile entegrasyon sağlandı.",                                 
                                "NVİ üzerinden TCKN kontrolü hesap parametrelerine bağlanarak aktif/deaktif edilebilir hale getirildi.",
                                "Kullanıcı kimlik bilgileri (TCKN ve Doğrum Tarihi) yalnızca oturum açan kullanıcı tarafından profil sayfasındaki 'Bilgilerimi Düzenle' ekranından değiştirilebilir hale getirildi.",
                                "Rapor filtrelerindeki seçim ekranlarında gelen kullanıcı listeleri departman bazlı filtrelendi.",
                                "Açıklama alanları için sınırlandırmalar gösterildi.",
                                "Alıcılar için 'Yeniden Gönder' butonu işi oluşturan kullanıcı tarafından da kullanılabilir hale getirildi.",
                                "İmza taslağı kullanılmadığında varsayılan imza konumu için ilk veya son sayfa seçilebilmesi sağlandı. (Hesap Parametreleri üzerinden tanımlanabilir)",
                                "Departman tanımları ekranından, ilgili departmana kullanıcı ekleme/çıkarma özelliği eklendi.",
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "'Yeniden Bildirim Gönder' butonu yalnızca işi oluşturan veya admin kullanıcılarda görünecek şekilde sınırlandırıldı.",
                                "'Revize Et' butonu için Raporlama yetkisi ihtiyacı kaldırıldı.",
                                "Aynı adımda birden fazla kullanıcı olması durumunda Bekleyen Kullanıcı alanında yalnızca imzası beklenen kullanıcının gösterilmesi sağlandı.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.7.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [                  
                                "TürkKEP ile entegrasyon sağlandı.", 
                                "Dış imzacı arayüzünün mobil uyumluluğu arttırıldı.",
                                "Kullanıcı tarafından tanımlanan kimlik bilgileri ekranına mobil imza alanları eklendi.",
                                "OnPrem LDAP senkronizasyonunun manuel tetiklenebilmesi sağlandı.",                          
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "EYP oluştur ekranındaki sorunlar giderildi.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.6.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [                                                
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.6.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [      
                                "KEP Yönetim Modülü için 'Giden Kutusu' ve 'Yeni İleti Gönder' menüleri eklendi.",
                                "Dış imzacıların, iş detaylarına erişim öncesinde kimliğini doğrulayabilmesi için MFA (SMS, E-İmza, Mobil İmza) özelliği eklendi.",
                                "İş oluştur ekranına canlı uyarılar eklendi.",
                                "Alıcı türü 'E-Posta' olan alıcılar için mail içeriğinde varsayılan e-posta taslağının kullanılması sağlandı.",
                                "Hesap bazında tarih formatının belirlenebilmesi sağlandı.",
                                "OnPrem kurulumlar için Alıcı tipi olarak 'Dosya Sistemi' eklendi.",                                                 
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Alıcı için belirlenen dosya limiti sıfır ise dolaşıma çıkarmaya izin vermeme sorunu giderildi.",
                                "Departman bağımsız bir akışa bağlı alıcıların, departman değişiklikleri engellendi.",
                                "İş listelerinde, dış kullanıcıda bekleyen işler için 'Bekliyor' sütunu boş gözüküyor problemi giderildi.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.5.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [      
                                "KEP Yönetim Modülü eklendi.",
                                "Dolaşıma çıkan işlerin revize edilebilmesi sağlandı.",
                                "İş içerisindeki red ve iptal adımlarına ait görseller düzeltildi.",
                                "Raporlama ekranına 'İmzalayan / Onaylayan' ve 'KEP ile gönderdiğim' filtreleri eklendi.",
                                "İşlerim sayfasına 'KEP ile gönderdiğim' filtresi eklendi.",
                                "Dashboard ekranındaki İşlerim alanına 'Başlattığım İşler' eklendi.",                                
                                "Günlük hatırlatma maillerinin kullanıcı bazında kapatılabilmesi sağlandı.",
                                "OnPrem kurulumlarda Günlük hatırlatma maillerinin özelleştirilerek istenilen saatlerde gönderilebilmesi sağlandı.",
                                "OnPrem kurulumlarda ADFS ile entegrasyon sağlandı.",                                                         
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "İş oluştururken şifreli veya desteklenmeyen formattaki PDF dosyalarının imzalanmak üzere eklenmesi engellendi.",
                                "Dış imzacılara ait açıklamaların iş akışında gösterilmesi sağlandı.",                                
                                "İş oluştur ekranında, sayfa temizlendikten sonra dosya ekleme sekmesinde kalan hata mesajları temizlendi.",
                                "KEP yetkili tanımları için yalnızca 'KEP İşlem Yetkilisi' olan kullanıcıların seçilebilmesi sağlandı.",
                                "Dashboard ekranındaki İş Yönetimi alanından gelen özet veriler kullanıcının yetkili olduğu departmanlara göre filtrelendi."
                            ]
                        }
                    ]
                },
                {
                    number : "2.4.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [      
                                "İmza Yerleştir ekranında düzenlemeler yapıldı. (Bu değişiklikler nedeniyle tanımlı şablonların tekrar oluşturulması gerekmektedir)",
                                "İmza Yerleştir şablonları kullanıcıya özel hale getirildi. Tüm kullanıcılar kendi şablonları oluşturabilecek ve düzenleyebilecek.",
                                "Eklerin alıcılara gönderilebilmesi sağlandı.",
                                "Giriş ekranında hesap kodu ve kullanıcı adının otomatik getirilmesi sağlandı.",
                                "İş akış adımları üzerinden bekleyen kullanıcıya hatırlatma maili gönderilebilmesi sağlandı.",
                                "Azure AD ile entegrasyon sağlandı.",
                                "TCKN bilgilerinin kullanıcılar tarafından girilmesi sağlandı.",
                                "İmza Doğrulama sayfasında imzacılar için Zaman Damgası tarihleri eklendi.",
                                "Mobil uygulama üzerinden giriş yapıldıktan sonra diğer şirketlere geçiş imkanı sağlandı.",                          
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        }
                    ]
                },
                {
                    number : "2.3.0",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "'Dolaşım Profili' ifadesi 'Akış', 'Hedef Sistem' ifadesi 'Alıcı' olarak değiştirildi.",                                
                                "PDF dosyaları için dosya adına tıklandığında yeni sekmede görüntüleme yapılması sağlandı.",
                                "Doküman Tipi alanı kaldırılarak Kategori tanımları oluşturuldu ve kullanıcılar tarafından tanımlanabilir hale getirildi.",
                                "PDF dosyalarında imzacı ismi yerine 2 boyutlu imza görselinin eklenebilmesi sağlandı.",
                                "Raporlar ekranında Kategoriler bazlı raporlama yapılabilmesi sağlandı.",
                                "KEP delillerinin güncellenmesi sırasında eğer KEP oturumu kapanmış ise yeniden oturum açma imkanı sağlandı.",
                                "Alıcı tanımlarında, alıcıya tek seferde iletilebilecek toplam dosya boyutu için sınırlama imkanı sağlandı.",
                                "Akış başladıktan sonra içerisine ek eklenebilmesi sağlandı.",
                                "Arayüzde kullanıcı deneyimini iyileştirmeye yönelik düzenlemeler yapıldı.",
                                "Kullanıcı ekran çözünürlüğüne göre tarayıcı zoom oranının otomatik ayarlanması sağlandı.",                                
                                "Parola politikası detaylandırıldı. Parolalar en az bir harf, bir rakam içerecek şekilde en az 8 karakter ve son üç paroladan farklı olmalıdır.",
                                "Lisans ve modüller ile ilgili ekranlar ve kullanıcı bilgilendirmeleri düzenlendi.",
                                "Dosya yükleme esnasında çıkan server hataları detaylandırılarak daha anlaşılır hale getirildi.",
                                "KEP ve Mail alıcılarının tanımlanmasında @kep.tr domain kontrolü eklendi.",
                                "Mail bildirimlerinden işi oluşturan kullanıcının cep telefonu bilgisi kaldırıldı.",
                                "Kullanıcı listesinden alınan excel çıktısına yetkilerin sütunu eklendi.",
                                "Kullanıcı profili sayfasına oturum geçmişi eklendi.",
                                "Versiyon notları eklendi.",
                                "Dış imzacılar için mobil imza ile imzalama özelliği eklendi.",
                                "Dış imzacı tarafından ek dosya eklenebilmesi sağlandı.",
                                "OnPrem Active Directory entegrasyonu için Security Group bazlı kullanıcı yönetimi eklendi.",
                                "OnPrem kurulumlar için parola servisleri entegrasyonu sağlandı.",
                                "Çeşitli hata düzeltmeleri.",
                                "Güvenlik düzenlemeleri."
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "İmzacı adının sayfanın sol üstünde çıkması ile ilgili sorun düzeltildi.",
                                "EYP 2.0 paketlerinde 'Çok İvedi' seçeneğinin çıkmaması sağlandı.",                                
                                "Pasife çekilen kullanıcılar için TCKN kontrolü kaldırıldı."
                            ]
                        }
                    ]
                },
                {
                    number : "2.2.1",
                    groups : [
                        {
                            header : "Yeni Özellikler",
                            notes : [
                                "Mobil imza ile login özelliği eklendi.",
                                "XML formatında talimat imzalama özelliği eklendi.",
                                "İşlerin departmana göre filtrelenebilmesi sağlandı.",
                                "KEP ileti tipi eYazisma olan iletilerin gönderimi sağlandı.",
                                "SFTP Hedef Sistem tanımlarına test özelliği eklendi.",
                                "SFTP Hedef Sistem tanımlarında uzak dizin seçilebilmesi için gözat butonu eklendi.",
                                "Mobil imzalama işleminin ardından imza doğrulaması eklendi.",
                                "İmza Doğrulama sayfasından işin adı kaldırıldı.",
                                "Sadece 'İş Oluştur' yetkisi olan kullanıcıların, 'İşlerim' sayfasının sadece 'Başlattığım İşler' filtresini kullanması sağlandı.",
                                "KEP ve Mail Hedef Sistem tanımlarında 'kep.tr' domain kontrolü eklendi.",
                                "İş içerisindeki İmzalı/İmzasız dosyaların görüntülenmesi ve indirilmesi için düzenleme yapıldı.",
                                "Dış imzacılarda TCKN zorunluluğu hesap parametrelerine bağlandı.",
                                "Talimat tutarı zorunluluğu hesap parametrelerine bağlandı.", 
                            ]
                        },
                        {
                            header : "Bug Düzeltmeleri",
                            notes : [
                                "Uygulama genelinde iyileştirmeler ve hata düzeltmeleri.",
                                "Benzer iş oluştur işleminde doküman tipinin aktarılması sağlandı.",
                                "İmza Yerleştir sayfasında imzacı isim ve soy isminin, yerleştirilen konumun daha üstünde çıkması sorunu düzeltildi.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.2.0",
                    groups : [
                        {
                            notes : [
                                    "Dış imzacı modülü eklendi.",
                                    "EYP 2.0 entegrasyonu eklendi.",                   
                                    "On-Premise kurulumlar için Active Directory (LDAP) entegrasyonu eklendi.",
                                    "PDF imza/metin yerleşim şablonları eklendi.",
                                    "Mail gönerimleri için şablon tasarımı eklendi.", 
                                    "Mail bildirimlerinin kullanıcı bazında yönetimi eklendi.",  
                                    "API entegrasyon alt yapısı geliştirildi.",
                                    "Çeşitli hata düzeltmeleri.",
                                    "Güvenlik düzenlemeleri.",
                            ]
                        }
                    ]
                },
                {
                    number : "2.1.0",
                    groups : [
                        {
                            notes : [
                                    "Mobil uygulama desteği eklendi.",
                                    "Çeşitli hata düzeltmeleri.",
                                    "Güvenlik düzenlemeleri.",
                            ]
                        }
                    ]
                },
            ];
        }
    }
}

</script>

<style scoped>
.closeButton{
    position: fixed;
    z-index: 999;
    right: 5px;
}
</style>